// src/pages/CourtListPage.js
import React, { useEffect } from "react";
import CourtList from "../components/CourtModule/CourtList";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const CourtListPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("auth_token");
    if (!token) {
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
  }, [navigate]);
  return <CourtList />;
};

export default CourtListPage;
